import {inject} from '@angular/core';
import {CanMatchFn, Route, Router, UrlSegment} from '@angular/router';
import {isLegacyEnvironmentRedirectUrlWithAuthParams} from '../types/navigation-management.types';

/**
 * Guard that checks if the current URL contains legacy redirect parameters
 * (access_token, refresh_token, tenant) and redirects to the appropriate component
 */
export function LegacyRedirectMatcher(): CanMatchFn {
	return (route: Route, segments: UrlSegment[]) => {
		const router: Router = inject(Router);
		
		// Parse current URL parameters
		const urlParams = new URLSearchParams(window.location.search);
		const urlParamsObject = Object.fromEntries(urlParams.entries());
		
		// Check if this is a legacy redirect with auth parameters
		if (isLegacyEnvironmentRedirectUrlWithAuthParams(urlParamsObject)) {
			// This should be handled by the RedirectLoginComponent
			// Navigate to the redirect route which will handle the legacy parameters
			router.navigate(['/redirect'], { 
				queryParams: urlParamsObject,
				replaceUrl: true // Replace current URL to avoid history issues
			});
			return false;
		}
		
		// This is not a legacy redirect, allow normal login flow
		return true;
	};
}
